import React from 'react';
import PropTypes from 'prop-types';
import { Section } from '..';
import { checkSectionCondition } from '../../Form.helpers';

const ContactData = ({ form, translations }) => {
    const data = form.shortContactData;
    const { country, region, city } = data;

    const dataArray = [city, country, region];
    const renderedSection = checkSectionCondition(dataArray);

    return (
        <>
            <Section.Conditional
                condition={Boolean(data.order) && renderedSection}
                title={translations.shortContactData}
            >
                {({ renderField }) => (
                    <>
                        {renderField(translations.country, data.country)}
                        {renderField(translations.region, data.region)}
                        {renderField(translations.city, data.city)}
                    </>
                )}
            </Section.Conditional>

        </>
    );
};
ContactData.propTypes = {
    form: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired
};

export default ContactData;
